import { isFunction } from 'coreutils-js';
import { AxiosInstance } from 'axios';

class API {
	props: any;
	instance: AxiosInstance;

	constructor(props) {
		this.props = props;
	}

	createInstance(baseURL, createInstanceFunction) {
		if (isFunction(createInstanceFunction)) {
			return createInstanceFunction.apply(this, [baseURL, this.props]);
		} else {
			return null;
		}
	}
}

export default API;